import React from "react";
import { FaTimes } from "react-icons/fa";

/**
 * Commissions-style active filter badges with per-chip remove.
 */
export default function ActiveFilterChips({ chips, onRemove, onClearAll, clearAllLabel = "Clear all" }) {
  if (!chips?.length) return null;

  return (
    <div className="mt-3.5 flex flex-wrap items-start justify-between gap-3 border-t border-[#E2E8F0] pt-3.5">
      <div className="flex min-w-0 flex-1 flex-wrap items-center gap-x-2 gap-y-1.5">
        <span className="shrink-0 text-[12px] font-medium text-gray-500">Active filters:</span>
        {chips.map((chip) => (
          <span
            key={chip.id || chip.key}
            className="inline-flex max-w-[min(100%,280px)] items-center gap-1 rounded-md border border-[#007BFF]/20 bg-[#007BFF]/10 py-1 pl-2.5 pr-1.5 text-[12px] font-medium text-[#007BFF]"
          >
            <span className="truncate">{chip.label}</span>
            <button
              type="button"
              onClick={() => onRemove(chip)}
              className="flex h-4 w-4 shrink-0 items-center justify-center rounded text-[#007BFF]/70 transition hover:bg-[#007BFF]/15 hover:text-[#007BFF]"
              aria-label={`Remove ${chip.label}`}
            >
              <FaTimes size={9} />
            </button>
          </span>
        ))}
      </div>
      {onClearAll && (
        <button
          type="button"
          className="shrink-0 border-0 bg-transparent p-0 text-[12px] font-semibold text-[#007BFF] hover:text-[#0069d9] hover:underline"
          onClick={onClearAll}
        >
          {clearAllLabel}
        </button>
      )}
    </div>
  );
}
